import { MonitoringData } from "../types/type";

export class Span {
  private traceId: string;
  private spanId: string;
  private parentSpanId?: string;
  private action: string;
  private startTime: number;
  private endTime?: number;
  private status?: string;
  sdk: any;

  constructor({ traceId, spanId, action, parentSpanId, sdk }) {
    this.traceId = traceId;
    this.spanId = spanId;
    this.action = action;
    this.parentSpanId = parentSpanId;
    this.startTime = Date.now();
    this.sdk = sdk;
  }

  public addStaus(status: string) {
    this.status = status;
    this.sdk.report(this.getData());
  }

  // 结束 span
  public end(status: string) {
    this.endTime = Date.now();
    this.status = status;
    this.sdk.report(this.getData());
  }

  // 获取 span 数据
  public getData() {
    const data: MonitoringData = {
      traceId: this.traceId,
      spanId: this.spanId,
      pspanId: this.parentSpanId,
      action: this.action,
      timestamp: Date.now(),
      elapsed: this.endTime ? this.endTime - this.startTime : undefined,
      status: this.status,
    };

    return data;
  }
}
